export const GET_CUSTOMER_REQUESTS = "GET_CUSTOMER_REQUESTS";
export const GET_CUSTOMER_RFP_QUOTATIONS = "GET_CUSTOMER_RFP_QUOTATIONS";
export const DELETE_RFP = "DELETE_RFP";
export const EDIT_RFP = "EDIT_RFP";
export const GET_OFFERS_KITS = " GET_OFFERS_KITS"
export const UPDATE_RFP_STATUS = "UPDATE_RFP_STATUS"